<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  #app{
    overflow-x: hidden;
    overflow-y: visible;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue